import React from 'react';
import { Hero } from '../components/Hero';
import { ClassFormats } from '../components/ClassFormats';
import { WhyDesertSage } from '../components/WhyDesertSage';
import { Testimonials } from '../components/Testimonials';
import { SupportCTA } from '../components/SupportCTA';
import { ListenInsteadOfReading } from '../components/ListenInsteadOfReading';
export function HomePage() {
  return <>
      <Hero data-id="element-773" />
      <ClassFormats data-id="element-774" />
      <WhyDesertSage data-id="element-775" />
      <Testimonials data-id="element-776" />
      <SupportCTA data-id="element-777" />
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 pb-16" data-id="element-778">
        <ListenInsteadOfReading data-id="element-779" />
      </div>
    </>;
}